// Backend rejects URL regex rules longer than 1,000 characters (EW-16189),
// so the URL Rule field is validated against the same limit client-side.
export const MAX_URL_RULE_LENGTH = 1000;

export const URL_RULE_MAX_LENGTH_ERROR_MESSAGE = `URL rule can’t be longer than ${MAX_URL_RULE_LENGTH.toLocaleString()} characters`;
